// The code in this file will load on every page of your site

import wixWindowFrontend from 'wix-window-frontend';

$w.onReady(function () {
	// Write your code here
	let language = wixWindowFrontend.multilingual.currentLanguage;
	let now = new Date();
	if (language== "it"){
		$w('#footerCopyrightText').text = `© ${now.getFullYear()} by Datasoluzioni. PIVA: IT02611360468- REA: MI - 2635014. Tutti i diritti sono riservati.`;
	}
	else if (language== "en")
	{
  		$w('#footerCopyrightText').text = `© ${now.getFullYear()} by Datasoluzioni. VATN: IT02611360468- REA: MI - 2635014. All rights are reserved.`;
	}
    
});